import { useParams } from 'react-router';
import useQuizQuestions from '../../../hooks/useQuizQuestions';
import BackLink from '../../../components/ui/BackLink';
import QuestionManagementForm from '../../../components/QuestionManagementForm';

const QuizQuestionManagementPage = () => {
  const { quiz_id } = useParams();
  
  const {
    quiz,
    loading,
    error: pageError,
  } = useQuizQuestions(quiz_id);

  if (loading) {
    return <div className="text-center py-4">Loading quiz details...</div>;
  }

  if(pageError){
    return    <p className="text-center text-gray-600">{pageError}🥲.</p>
  }

  if (!quiz) {
    return <div className="text-center py-4">Quiz not found</div>;
  }

  return (
    <div className="container mx-auto px-4 py-6 max-w-7xl">
      <div> 
        <BackLink/>
        <h1 className="text-4xl font-medium font-inter text-gray-800">{quiz.topic_detail.title}</h1>
        <div className="text-gray-700 text-2xl">#{quiz.id.substring(0, 8)} - {quiz.quiz_type}</div>

        <QuestionManagementForm
          parentType={'quiz'}
          parentId={quiz_id}
          initialQuestions={quiz.questions}
          topicId={quiz.topic}
        />
      </div>
    </div>
  );
};

export default QuizQuestionManagementPage;
